import { Button, useTranslate } from 'react-admin';
import FileManagerModalInputPreview from './FileManagerModalInputPreview';

interface FileManagerInputItemProps{
  onClick: () => void,
  value?: any,
  mode?: 'image' | 'file',
  icon: any,
  label?: string,
}
const FileManagerInputItem = (props: FileManagerInputItemProps) => {
  const { onClick, value, mode, icon, label, ...rest } = props;
  const translate = useTranslate();

  if ('image' === mode) {
    return (
      <div onClick={onClick} style={{ width: '100%', height: '200px', maxHeight: '400px', backgroundColor: 'lightgray', padding: '10px', position: 'relative', borderRadius: '10px' }}>
        <FileManagerModalInputPreview value={value} mode={mode} />
        <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button variant="contained" label={translate('ra.action.file_manager')} onClick={onClick} {...rest}>{icon}</Button>
        </div>
      </div>
    )
  } else if ('file' === mode) {
    return <div style={{ display: 'flex', flexDirection: 'row' }}>
      <Button variant="contained" label={translate('ra.action.file_manager')} onClick={onClick} {...rest}>{icon}</Button>
      <FileManagerModalInputPreview value={value} mode={mode} />
    </div>
  } else {
    return <Button label={translate('ra.action.file_manager')} onClick={onClick} {...rest}>{icon}</Button>
  }
}
export default FileManagerInputItem;